import React from 'react';

const PrivacyPage = () => (
  <main className="max-w-3xl mx-auto p-8 text-gray-800 bg-warmWhite rounded shadow mt-12">
    <h1 className="text-3xl font-bold mb-6 text-turquoise">Integritetspolicy</h1>

    <p className="mb-4 text-sm">Senast uppdaterad: 14 april 2025</p>

    <h2 className="text-xl font-semibold mt-6 mb-2">1. Vilka vi är</h2>
    <p className="mb-4">
      Barnboken.se är en plattform som erbjuder AI-genererade böcker och ljudböcker. Du når oss på <a href="mailto:support@barnboken.se" className="text-blue-600 hover:underline">support@barnboken.se</a>.
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">2. Vilka uppgifter vi samlar in</h2>
    <ul className="list-disc list-inside mb-4">
      <li>Namn, adress, postnummer, land</li>
      <li>E-post och användarnamn</li>
      <li>Stripe ID (för utbetalningar)</li>
      <li>Data om bokskapande (berättelser, avatarer)</li>
      <li>Tekniska uppgifter (IP-adress, webbläsare)</li>
    </ul>

    <h2 className="text-xl font-semibold mt-6 mb-2">3. Vad vi använder uppgifterna till</h2>
    <ul className="list-disc list-inside mb-4">
      <li>För att skapa och leverera personaliserade produkter</li>
      <li>För att kommunicera med dig</li>
      <li>För att genomföra betalningar</li>
      <li>För att förbättra användarupplevelsen</li>
      <li>För att följa lagkrav</li>
    </ul>

    <h2 className="text-xl font-semibold mt-6 mb-2">4. Delning av uppgifter</h2>
    <p className="mb-4">
      Vi delar endast data med:
    </p>
    <ul className="list-disc list-inside mb-4">
      <li>Stripe (för betalning)</li>
      <li>Amazon/ElevenLabs (för ljudsyntes)</li>
      <li>OpenAI (för textgenerering)</li>
      <li>Vår databas (för att lagra användarprojekt)</li>
    </ul>
    <p className="mb-4">
      Vi säljer <strong>aldrig</strong> dina uppgifter.
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">5. Dina rättigheter</h2>
    <ul className="list-disc list-inside mb-4">
      <li>Få tillgång till dina uppgifter</li>
      <li>Ändra eller radera uppgifter</li>
      <li>Be om att inte bli kontaktad</li>
      <li>Radera ditt konto helt</li>
    </ul>

    <h2 className="text-xl font-semibold mt-6 mb-2">6. Cookies och spårning</h2>
    <p className="mb-4">
      Vi använder cookies för inloggning och analys (t.ex. Google Analytics). Du kan neka detta i din webbläsare.
    </p>

    <h2 className="text-xl font-semibold mt-6 mb-2">7. Kontakt</h2>
    <p className="mb-4">
      För frågor om din integritet, kontakta oss på:
      <br />📩 <a href="mailto:support@barnboken.se" className="text-blue-600 hover:underline">support@barnboken.se</a>
    </p>
  </main>
);

export default PrivacyPage;
